import Vue from 'vue';
import VueRouter from 'vue-router';

import Forbidden from 'views/pages/common/403.vue';
import NotFound from 'views/pages/common/404.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "user" */ 'views/pages/login/FirstPage.vue')
  },
  {
    path: '/loginPage',
    name: 'LoginPage',
    component: () => import( /* webpackChunkName: "user" */ 'views/pages/login/Login.vue')
  },
  {
    path: '/applist',
    name: 'AppList',
    component: () => import(/* webpackChunkName: "user" */ 'views/pages/login/AppList.vue'),
    children: [
      {
        path: '/applist/appdown',
        name: 'AppDownloadPage',
        component: () =>
          import(/* webpackChunkName: "user" */ 'views/pages/login/AppDownloadPage.vue')
      }
    ]
  },
  {
    path: '/protocol',
    name: 'Protocol',
    component: () => import(/* webpackChunkName: "user" */ 'views/pages/login/Protocol.vue')
  },
  {
    path: '/register',
    component: () =>
      import(
        /* webpackChunkName: "user" */ 'views/pages/register/register-layout/RegisterLayout.vue'
      ),
    redirect: '/register/phone',
    children: [
      {
        path: '/register/phone',
        name: 'Register',
        component: () =>
          import(/* webpackChunkName: "user" */ 'views/pages/register/register/Register.vue')
      },
      {
        path: '/register/findpassword',
        name: 'FindPassword',
        component: () =>
          import(
            /* webpackChunkName: "user" */ 'views/pages/register/find-password/FindPassword.vue'
          )
      },
      {
        path: '/register/applytrial',
        name: 'ApplyTrial',
        component: () =>
          import(/* webpackChunkName: "user" */ 'views/pages/register/apply-trial/ApplyTrial.vue')
      },
      {
        path: '/register/systemselect',
        name: 'SystemSelect',
        component: () =>
          import(
            /* webpackChunkName: "user" */ 'views/pages/register/system-select/SystemSelect.vue'
          )
      }
    ]
  },
  {
    path: '/home',
    component: () => import(/* webpackChunkName: "home" */ 'views/layout/BasicLayout.vue'),
    redirect: '/home/system',
    children: [
      {
        path: '/home/system',
        name: 'SystemMangement',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/system-mangement/SystemMangement.vue'
          )
      },
      {
        path: '/home/org',
        name: 'OrgMangement',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/org-mgr/index.vue'
          )
      },
      {
        path: '/home/users',
        name: 'UserMangement',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/users-mangement/UserMangement.vue'
          )
      },
      {
        path: '/home/access',
        name: 'AccessLog',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/log-mangement/log-access/AccessLog.vue'
          )
      },
      {
        path: '/home/action',
        name: 'ActionLog',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/log-mangement/log-action/ActionLog.vue'
          )
      },
      {
        path: '/home/dictionary',
        name: 'DictionaryMangement',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/dictionary-mangement/DictionaryMangement.vue'
          )
      },
      {
        path: '/home/onlineusers',
        name: 'OnlineUsers',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/users-online/OnlineUsers.vue')
      },
      {
        path: '/home/trialusers',
        name: 'TrialUsers',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/users-trial/TrialUsers.vue')
      },
      {
        path: '/home/flowmonitoring',
        name: 'FlowMonitoring',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/flow-monitoring/FlowMonitoring.vue'
          )
      },
      // {
      //   path: '/home/device',
      //   name: 'Device',
      //   component: () => import(/* webpackChunkName: "home" */ 'views/pages/home/device/Device.vue')
      // },
      {
        path: '/home/dealmangement',
        name: 'DealMangement',
        component: () => import(/* webpackChunkName: "home" */ 'views/pages/home/deal-mangement/DealMangement.vue')
      },
      {
        path: '/home/devicemangement',
        name: 'DeviceMangement',
        component: () => import(/* webpackChunkName: "home" */ 'views/pages/home/device-mangement/DeviceMangement.vue')
      },
      {
        path: '/home/devicetype',
        name: 'DeviceType',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/device-mangement/device-type/DeviceType.vue')
      },
      {
        path: '/home/devicebrand',
        name: 'DeviceBrand',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/device-mangement/device-brand/DeviceBrand.vue')
      },
      {
        path: '/home/deviceparameter',
        name: 'DeviceParameter',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/device-mangement/device-parameter/DeviceParameter.vue')
      },
      {
        path: '/home/deviceseries',
        name: 'DeviceSeries',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/device-mangement/device-series/DeviceSeries.vue')
      },
      // {
      //   path: '/home/devicetype',
      //   name: 'DeviceType',
      //   component: () =>
      //     import(/* webpackChunkName: "home" */ 'views/pages/home/device-type/DeviceType.vue')
      // },
      {
        path: '/home/deviceauthorization',
        name: 'DeviceAuthorization',
        component: () =>
          import(
            /* webpackChunkName: "home" */ 'views/pages/home/device-authorization/DeviceAuthorization.vue'
          )
      },
      {
        path: '/home/appmangement',
        name: 'AppMangement',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/app-mangement/AppMangement.vue')
      },
      {
        path: '/home/srsmangement',
        name: 'SrsMangement',
        component: () =>
          import(/* webpackChunkName: "home" */ 'views/pages/home/srs-mangement')
      }
    ]
  },
  {
    path: '/403',
    name: '403',
    component: Forbidden,
    hideInMenu: true
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
    hideInMenu: true
  }
];

const router = new VueRouter({
  routes
});

export default router;
